import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar,
   IonButton,
   IonLabel,
   IonIcon,
   IonGrid,
   IonRow,
   IonCol,
   IonCard,
   IonCardHeader,
   IonCardContent,
   IonToast,
   IonLoading,
   useIonAlert,
   IonModal
} from '@ionic/react';
import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './Signature.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import { useForm, Controller } from 'react-hook-form';
import { arrowUndo, checkmarkCircle, cloudUpload, image, pencil, trashBin } from 'ionicons/icons';
import SignaturePad from 'react-signature-pad-wrapper';
import { useOrientation } from 'react-use';
import ServerService from '../../../services/Server';

const JSON5 = require("json5")

const Signature: React.FC = () => {

  const { control, handleSubmit, formState:{errors}, formState, clearErrors} = useForm({
    mode:'onSubmit'
  });

const server = new ServerService();
var state = server.state;

const history = useHistory();

const { type } = useOrientation();

const signaturePad = useRef(null);

const [showWarning, setShowWarning] = useState(false);
const [showLoading, setShowLoading] = useState(false);
const [showMsg, setShowMsg] = useState(false);

const [presentAlert] = useIonAlert();


const isPortrait = () => {
  return type.indexOf('landscape-secondary') < 0;
}

const getSignaturePad = () => {
  return isPortrait() ? signaturePad.current : signaturePad.current;
}

const btnUndoClick = () => {
  var signaturePad = getSignaturePad();

  const data = signaturePad.toData();
  if (data) {
    data.pop(); // remove the last dot or line
    signaturePad.fromData(data);
  }
}

const btnClearClick = () => {
   getSignaturePad().clear();
}

const resizeSignaturePad = () => {
  
  const signaturePad = getSignaturePad();
  //const ratio =  Math.max(window.devicePixelRatio || 1, 1);
  const canvas = signaturePad.canvasRef.current;

  if (canvas['offsetHeight']>0 && canvas['offsetWidth']>0) {
    canvas.height = canvas['offsetHeight'];
    canvas.width = canvas['offsetWidth'];
//    signaturePad.canvasRef.current.height = signaturePad.canvasRef.current['offsetHeight'] * ratio;
//    signaturePad.canvasRef.current.width = signaturePad.canvasRef.current['offsetWidth'] * ratio;
    //signaturePad.canvasRef.current.getContext("2d").scale(ratio, ratio);
    signaturePad.canvasRef.current.style.backgroundColor = "white";

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.rect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = 'white';
    ctx.fill();
  }
  
}

const btnBrowseClick = () => {
  alert("browse");
}

const btnUploadClick = () => {  
   var signaturePad = getSignaturePad();
   if (signaturePad.isEmpty()) {
      setShowWarning(true);
      return;
   }

   setShowLoading(true)

   var data = signaturePad.toDataURL();

   // cut "data:image/png;base64,"
   data = data.substring(22);

   var params = {
      s : data
   }

   fetch(server.getPrefixUrl()+"mb/signature/sign",
        server.postRequest(params,{'Bg-Source':'Mobile'})
      ).then(
      response => {
      if(response.ok) {
        response.json().then(res => {
      
          if (res.success) {
            console.log("success")
            setShowMsg(true)
    
            setShowLoading(false)
          } else {
            if (!res.data) {
              showError({msg:res.message})
            }
            else
            if (!res.data.valid) {
              console.log("!success:"+res.data.valid+":"+res.data.msg);
              const msg = res.data.msg;
              if (msg.startsWith("|BG_ERR|")) {
                showError({msg:msg.substring("|BG_ERR|".length)})
              } else {
                showError({msg:msg})
              }
    
            }
          }
        }).catch(
          error => {
            setShowLoading(false);
            console.log(error) // Handle the error response object
          }
        );

      } else {
        if (response.status == 404) {
          alert("Error:"+server.getPrefixUrl()+"mobile/signature"+ " : Not Found");
        } else {
          alert("Error:"+response.status+":"+response.statusText);
        }
      }
    });
}

const okBtn = 
{
  side: 'end',
  icon: checkmarkCircle,
  text: 'OK',
  role: 'cancel',
  handler: () => {
    setShowLoading(false);
  }
}

const showError = (opt:any) => {
  setShowLoading(false);
  presentAlert({
    header: 'Error',
    message: opt.msg,
    buttons: opt.btns ? opt.btns : [okBtn],
    backdropDismiss: false
  })
}

useEffect(() => {
    // callback function to call when event triggers
    const onPageLoad = () => {
      console.log('page loaded');
      // do something else
      const timeoutId = setTimeout(() => {
        resizeSignaturePad();
      }, 1000);

      // Cleanup function to clear the timeout if the component unmounts
      return () => clearTimeout(timeoutId);
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);

  return (
    <IonPage>
      {isPortrait() ?
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>
          <IonTitle>{"Signature"}</IonTitle>
        </IonToolbar>
      </IonHeader>
      :
      ""
      }

      <IonContent>
            <IonCard color="dark">
                <IonCardHeader color="dark">
                {isPortrait() ?
                <IonToolbar color="dark">
                  <IonButton slot="start" onClick={() => btnClearClick()} color="danger">
                    <div className="btn-icon-flex">
                      <IonIcon icon={trashBin}></IonIcon>
                      <IonLabel><strong>&nbsp;Clear</strong></IonLabel>
                    </div>
                  </IonButton>
                  <IonButton slot="start" onClick={() => btnUndoClick()} color="warning">
                    <div className="btn-icon-flex">
                      <IonIcon icon={arrowUndo}></IonIcon>
                      <IonLabel>&nbsp;Undo</IonLabel>
                    </div>
                  </IonButton>
{/*
                  <IonButton slot="end" onClick={() => btnBrowseClick()} >
                    <div className="btn-icon-flex">
                      <IonIcon icon={image}></IonIcon>
                      <IonLabel><strong>&nbsp;Browse</strong></IonLabel>
                    </div>
                  </IonButton>
*/}
                  <IonButton slot="end" onClick={() => btnUploadClick()} color="success">
                    <div className="btn-icon-flex">
                      <IonIcon icon={cloudUpload}></IonIcon>
                      <IonLabel><strong>&nbsp;Upload</strong></IonLabel>
                    </div>
                  </IonButton>
                </IonToolbar>
                :
                ""
                }
                </IonCardHeader>

              <IonCardContent>
                <IonGrid>
                  <IonRow>
                  <>
                    {!isPortrait() ?
                    <IonCol size="auto">
                      <div className="btn-ver-flex" style={{width:"80px"}}>
                      <IonButton onClick={() => btnClearClick()} color="danger">
                        <IonIcon icon={trashBin} slot="icon-only"></IonIcon>
                      </IonButton>
                      <IonButton onClick={() => btnUndoClick()} color="warning">
                        <IonIcon icon={arrowUndo} slot="icon-only"></IonIcon>
                      </IonButton>
                      <div style={{width:"100px"}}>&nbsp;</div>
{/*
                      <IonButton onClick={() => btnBrowseClick()}>
                        <IonIcon icon={image} slot="icon-only"></IonIcon>
                      </IonButton>
 */}                                            
                      <IonButton onClick={() => btnUploadClick()} color="success">
                        <IonIcon icon={cloudUpload} slot="icon-only"></IonIcon>
                      </IonButton>
                      </div>
                    </IonCol>
                    : ""
                  }
                    <IonCol>
                      <SignaturePad ref={signaturePad} redrawOnResize options={{dotSize:2.0,backgroundColor:'rgb(255,255,255)',penColor: 'rgb(0, 0, 0)'}} />
                    </IonCol>
                  </>
                  </IonRow>
                </IonGrid>
              </IonCardContent>

              </IonCard>
      </IonContent>

        <IonToast
          isOpen={showWarning}
          message="Please sign before upload"
          position="middle"
          onDidDismiss={() => setShowWarning(false)}
          icon={pencil}
          duration={5000}
        ></IonToast>

      <IonLoading 
              isOpen={showLoading}
              onDidDismiss={() => setShowLoading(false)}
              message="Please wait..."
            />

          <IonModal
            isOpen={showMsg}
            onDidDismiss={async () => {
              setShowLoading(false)
              setShowMsg(false)
            }}
            backdropDismiss={true}
            showBackdrop={true}
            className="success-modal"
            onDidPresent={()=>{
              setTimeout(()=>{
                setShowMsg(false)
              },6000)
            }}
          >
            <IonContent color="success">
              <IonLabel color="light" className="modal-msg"><b>Success</b></IonLabel>
            </IonContent>
          </IonModal>

    </IonPage>
  );
}

export default Signature;
